import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { CurrencyItem, GetCurrencyListParams } from '@/models/dictionary/currency-list.model';

export default class GetCurrencyListRequest extends ApiResourceMethod<CurrencyItem[]> {
  public perform({ isFetchFullList, wlSlug }: GetCurrencyListParams): Promise<CurrencyItem[]> {
    return this.performer.requestWithMapper(
      {
        params: {
          all: isFetchFullList,
        },
        url: `${wlSlug}/dictionary/currency`,
      },
      (payload: BaseResponse<CurrencyItem[]>) => {
        return payload.data;
      },
    );
  }
}
